<!-- Ported from vendor-ref/mara/app/ui/src/components/NRenamePrompt.vue -->
<script setup lang="ts">
import { nextTick, ref } from 'vue';
import Popover from 'primevue/popover';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

withDefaults(defineProps<{ type?: string }>(), { type: 'item' });
const emit = defineEmits<{ rename: [value: string] }>();

const panel = ref<InstanceType<typeof Popover>>();
const input = ref<{ $el: HTMLInputElement }>();
const value = ref('');

function hide() { panel.value?.hide(); }
function show(target: EventTarget | null, initialValue: string) {
  value.value = initialValue;
  setTimeout(() => {
    panel.value?.show({ currentTarget: target } as unknown as Event);
    nextTick(() => input.value?.$el?.focus());
  }, 0);
}
function submit() { emit('rename', value.value); hide(); }

defineExpose({ show, hide });
</script>

<template>
  <Popover ref="panel" pt:content="flex flex-col gap-2">
    <div class="text-sm">
      Rename {{ type }}
    </div>
    <form class="flex gap-2" @submit.prevent="submit">
      <InputText ref="input" v-model="value" class="rd-5" size="small" autofocus />
      <Button icon="i-tabler-check" type="submit" rounded />
    </form>
  </Popover>
</template>
